import React from "react";

import "../../../../styles/css/App.css";

import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import TablePlaces from "../table-places";
import PlaceForm from "../form/place-form";
import { PlaceCategories } from '../../../../plas/map/places/models';
import alerter from "../../../alerts/alerter.jsx";


function Culture({ history }) {
  
  let { path, url } = useRouteMatch();

  const onOpen = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  const onClose = () => {
    history.goBack()
  }

  const onSave = () => {
    onClose()
    alerter.showSuccess("Se guardaron los cambios del espacio cultural.")
  }

  const options = {
    contact: {
      delivery: 'hidden'
    }
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TablePlaces
            open={onOpen}
            rootCategory={PlaceCategories.CULTURE}
            title={"Espacios culturales"}
            deleteMessage="¿Está seguro de que desea borrar este espacio cultural?"
            noDataMessage="No hay espacios culturales para mostrar"
            options={options} />
        </Route>
        <Route exact path={`${path}/:businessId`}
          render={ (props) => 
            <PlaceForm 
              rootCategory={PlaceCategories.CULTURE} 
              placeId={props.match.params.businessId}
              onSave={onSave}
              options={options}
              onCancel={onClose}/>
          }
        />
      </Switch>
    </div>
  );

}

export default withRouter(Culture);
